import slick from "slick-carousel";
import Autolinker from "autolinker";
import toastr from "toastr";

const pageDetail = {
    toggleItem: function (target) {
        $(target).next().slideToggle();
        $(target).toggleClass("open");
    },

    // 問い合わせ
    inquiry: function (nurseryId, url, backToken) {
        var paramList = new FormData();
        paramList.append("nurseryId", nurseryId);

        if (backToken) {
            paramList.append("token", backToken);
        }

        post.postAjaxData(url, paramList, "", pageDetail.inquiryFirstDone, pageDetail.inquiryFirstFail, null);
    },

    // 初期表示に成功
    inquiryFirstDone: function (result) {
        $("#js-modal-contact-visit").html(result["template"]);

        // 確認ボタンを押したとき
        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            const url = $("#contactForm").attr("action");

            form.post(url, "#contactForm", "", pageDetail.inquiryConfirmLoadDone);
        });

        $(".modal__contents").scrollTop(0);
    },

    // 初期表示に失敗。ログインしていないなど。
    inquiryFirstFail: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR["status"] === 401) {
            // ログインできていないとき
            modalWindow.showModal("#js-modal-regist-guide");
        }
    },

    // ログインボタンや園からのメッセージの出し分け
    inquirySwitch: function (
        nurseryId,
        isVisitInquiryEnabled,
        isVisitInquiryEnabledByEnsagaso,
        isVisitInquiryEnabledByGovHokatsuKiban,
        isEtcInquiryEnabled,
        isEtcInquiryEnabledByEnsagaso
    ) {
        $(".js-first-display-form").show();
        if ((!isVisitInquiryEnabled && isEtcInquiryEnabled) || $("[id=etc]").prop("checked")) {
            $("#js-modal-visit-inquiry-login").hide();
            $("#js-modal-visit-inquiry-message").hide();
            $("#js-modal-etc-inquiry-message").show();

            if (isEtcInquiryEnabledByEnsagaso) {
                pageDetail.inquiry(nurseryId, "/parent/etcInquiry");
                $("#js-modal-etc-inquiry-login").show();
                $("#js-modal-contact-visit").show();
            } else {
                $("#js-modal-etc-inquiry-login").hide();
                $("#js-modal-contact-visit").hide();
            }
        } else {
            $("#js-modal-etc-inquiry-login").hide();
            $("#js-modal-visit-inquiry-message").show();
            $("#js-modal-etc-inquiry-message").hide();

            if (isVisitInquiryEnabledByEnsagaso) {
                pageDetail.inquiry(nurseryId, "/parent/visitInquiry");
                $("#js-modal-visit-inquiry-login").show();
                $("#js-modal-contact-visit").show();
            } else if (isVisitInquiryEnabledByGovHokatsuKiban) {
                pageDetail.inquiry(nurseryId, "/parent/govHokatsuKibanVisitInquiry");
                $("#js-modal-visit-inquiry-login").show();
                $("#js-modal-contact-visit").show();
            } else {
                $("#js-modal-visit-inquiry-login").hide();
                $("#js-modal-contact-visit").hide();
            }
        }
    },

    // 確認画面の表示
    inquiryConfirmLoadDone: function (results, paramList) {
        $(".js-first-display-form").hide();
        $("#js-modal-contact-visit").html(results["template"]);
        modalWindow.enableButton();

        // 戻るボタンを押したとき
        $(".js-back").unbind();
        $(".js-back").click(function () {
            $(".js-first-display-form").fadeIn();
            const url = $("#contactBackForm").attr("action");
            form.post(
                url,
                "#contactBackForm",
                "",
                pageDetail.inquiryFirstDone,
                function (jqXHR, textStatus, errorThrown) {
                    window.alert("エラーが発生しました。入力からやり直してください。");
                    location.reload();
                }
            );
        });

        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            const url = $("#contactCompleteForm").attr("action");
            form.post(
                url,
                "#contactCompleteForm",
                "",
                pageDetail.inquiryCompleteDone,
                function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 400) {
                        toastr.error("エラーが発生しました。入力からやり直してください。");
                    }
                    $(".js-back").click();
                }
            );
        });

        $(".modal__contents").scrollTop(0);
    },

    // 完了した
    inquiryCompleteDone: function (results, paramList) {
        $("#js-modal-contact-visit").html(results["template"]);
        modalWindow.enableButton();

        // 戻るボタンを押したとき
        $(".js-back").unbind();
        $(".js-back").click(function () {
            $(".js-first-display-form").fadeIn();
            const url = $("#contactBackForm").attr("action");
            form.post(url, "#contactBackForm", "", pageDetail.inquiryFirstDone);
        });

        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            const url = $("#contactCompleteForm").attr("action");
            form.post(url, "#contactCompleteForm", "", pageDetail.inquiryCompleteDone);
        });

        // 送信完了後に「その他お問合わせ」が選択状態になるものの解消
        $("[id=visit]").prop("checked", "checked");

        // キープされたことの画面への反映のため、見学申し込みだけクラスを追加している
        if (results["kind"] === "visitInquiry") {
            const nurseryId = document.querySelector(".js-detail-page").getAttribute("data-nursery_id");
            const buttons = document.querySelectorAll(`.js-favorite-button[data-nursery_id="${nurseryId}"]`);
            buttons.forEach((elm) => {
                elm.classList.add("active");
            });
        }

        $(".modal__contents").scrollTop(0);
    },

    // メモ編集を押したとき
    review: function (nurseryId) {
        post.postAjaxData(
            "/parent/authCheck",
            null,
            "",
            function (result) {
                if (result.isLoggedIn) {
                    window.location.href = "/ns/" + nurseryId + "/memo";
                    return;
                }

                const redirectParams = {
                    redirect: "memo",
                    nursery_id: nurseryId
                };
                modalWindow.showModal("#js-modal-regist-guide", redirectParams);
            },
            null,
            null
        );
    },

    // 画像のイメージを表示
    displayImage: function (object) {
        // 初期化
        $(".modal__big-pic").find("img").attr("src", "");
        $(".modal__big-pic").css("width", "");
        $(".modal__big-pic").css("height", "");
        $(".modal__container").css("width", "");

        const imgSrc = $(object).find("img").attr("src");
        $(".modal__big-pic").find("img").attr("src", imgSrc);
        $(".modal__big-pic").find(".modal__big-pic--content").text($(object).find("a").data("content"));

        // 画像が縦長の時、縮小して表示
        const win_h = $(window).height();
        let modal_w = $(".modal__big-pic").innerWidth();
        let modal_h = $(".modal__big-pic").innerHeight();
        let modal_ratio = 0;
        if (modal_h > win_h) {
            modal_h = win_h * 0.75;
            modal_ratio = modal_h / modal_w;
            modal_w = modal_h * modal_ratio;
            $(".modal__container").width(modal_w);
        }
    }
};
window.pageDetail = pageDetail;

// ボタンの定義
$(document).ready(function (e) {
    if ($(".js-detail-page").length === 0) {
        return;
    }

    // トグルボタンを押したとき
    $(".nursery-info__tab-ttl--toggle, .nursery-info__list-heading--faq").on("click", function () {
        pageDetail.toggleItem(this);
    });

    $(document).on("click", ".js-about-allergy-support", function () {
        pageDetail.toggleItem(this);
    });

    // 画像を押したとき
    $(".nursery-info__photo-pct").click(function () {
        // 画像の一覧を生成して、スワイプして表示できるようにする
        const imageList = $(this).parents("ul").find("li");
        let currentIndex = $(this).parents("li").index();

        // クリックした画像の表示
        pageDetail.displayImage(imageList[currentIndex]);

        if (imageList.length === 1) {
            $(".js-modal__big-pic-next").hide();
            $(".js-modal__big-pic-prev").hide();
        } else {
            $(".js-modal__big-pic-next").show();
            $(".js-modal__big-pic-prev").show();
        }

        $(".js-modal__big-pic-next").unbind("click");
        $(".js-modal__big-pic-prev").unbind("click");

        const maxIndex = imageList.length - 1;

        $(".js-modal__big-pic-next").on("click", function () {
            if (maxIndex === currentIndex) {
                currentIndex = 0;
            } else {
                currentIndex++;
            }
            pageDetail.displayImage(imageList[currentIndex]);
        });
        $(".js-modal__big-pic-prev").on("click", function () {
            if (currentIndex === 0) {
                currentIndex = maxIndex;
            } else {
                currentIndex--;
            }
            pageDetail.displayImage(imageList[currentIndex]);
        });

        let touchPosition = 0;
        let touchDirection = "left";
        $(".modal__big-pic").unbind("touchstart");
        $(".modal__big-pic").unbind("touchmove");
        $(".modal__big-pic").unbind("touchend");

        $(".modal__big-pic").on("touchstart", function (event) {
            touchPosition = event.originalEvent.touches[0].pageX;
        });
        $(".modal__big-pic").on("touchmove", function (event) {
            touchDirection = touchPosition > event.originalEvent.touches[0].pageX ? "left" : "right";
        });
        $(".modal__big-pic").on("touchend", function () {
            if (touchDirection === "left") {
                $(".js-modal__big-pic-next").trigger("click");
            } else {
                $(".js-modal__big-pic-prev").trigger("click");
            }
        });
    });

    // 問い合わせボタンを押したとき
    // 初期表示
    $("#js-button-contact").on("click", function () {
        const nurseryId = $(this).data("nursery_id");
        const isVisitInquiryEnabled = $(this).data("is-visit-inquiry-enabled");
        const isVisitInquiryEnabledByEnsagaso = $(this).data("is-visit-inquiry-enabled-by-ensagaso");
        const isVisitInquiryEnabledByGovHokatsuKiban = $(this).data("is-visit-inquiry-enabled-by-gov-hokatsu-kiban");
        const isEtcInquiryEnabled = $(this).data("is-etc-inquiry-enabled");
        const isEtcInquiryEnabledByEnsagaso = $(this).data("is-etc-inquiry-enabled-by-ensagaso");
        const isLoginRequiredForInquiry = $(this).data("is-login-required-for-inquiry");

        $("#js-modal-contact-visit").html("");

        // 非会員で基盤連携用の見学予約申請できないので、ログイン催促のモーダルを展開させる
        if (isLoginRequiredForInquiry) {
            const redirectParams = {
                redirect: "inquiry",
                nursery_id: nurseryId,
                kind: "visit"
            };
            modalWindow.showModal("#js-modal-regist-guide", redirectParams);
            return;
        }

        pageDetail.inquirySwitch(
            nurseryId,
            isVisitInquiryEnabled,
            isVisitInquiryEnabledByEnsagaso,
            isVisitInquiryEnabledByGovHokatsuKiban,
            isEtcInquiryEnabled,
            isEtcInquiryEnabledByEnsagaso
        );

        // 見学申し込みとお問い合わせのモーダルを展開する
        const redirectParams = {
            redirect: "inquiry",
            nursery_id: nurseryId
        };
        modalWindow.showModal("#js-modal-contact", redirectParams);
        modalWindow.enableButton();
    });

    //問い合わせ内容変更したとき
    $('[name="switch-content"]:radio').change(function () {
        const nurseryId = $("#js-button-contact").data("nursery_id");
        const isVisitInquiryEnabled = $("#js-button-contact").data("is-visit-inquiry-enabled");
        const isVisitInquiryEnabledByEnsagaso = $("#js-button-contact").data("is-visit-inquiry-enabled-by-ensagaso");
        const isVisitInquiryEnabledByGovHokatsuKiban = $("#js-button-contact").data(
            "is-visit-inquiry-enabled-by-gov-hokatsu-kiban"
        );
        const isEtcInquiryEnabled = $("#js-button-contact").data("is-etc-inquiry-enabled");
        const isEtcInquiryEnabledByEnsagaso = $("#js-button-contact").data("is-etc-inquiry-enabled-by-ensagaso");

        pageDetail.inquirySwitch(
            nurseryId,
            isVisitInquiryEnabled,
            isVisitInquiryEnabledByEnsagaso,
            isVisitInquiryEnabledByGovHokatsuKiban,
            isEtcInquiryEnabled,
            isEtcInquiryEnabledByEnsagaso
        );
    });

    // 見学申し込み・お問い合わせフォームからログインしてリダイレクトしてきたとき
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get("kind");

    if (paramValue) {
        const isVisitInquiryEnabledByEnsagaso = $("#js-button-contact").data("is-visit-inquiry-enabled-by-ensagaso");
        const isVisitInquiryEnabledByHokatsuKibanRenkei = $("#js-button-contact").data(
            "is-visit-inquiry-enabled-by-gov-hokatsu-kiban"
        );
        const isEtcInquiryEnabledByEnsagaso = $("#js-button-contact").data("is-etc-inquiry-enabled-by-ensagaso");

        if ((paramValue === "visit" && isVisitInquiryEnabledByEnsagaso) || isVisitInquiryEnabledByHokatsuKibanRenkei) {
            // ログイン後のモーダル表示の速度改善のため、アニメーションを削除
            $("#js-modal-contact").toggleClass("stop");
            $("[id=visit]").prop("checked", true);
            $("#js-button-contact").click();
        } else if (paramValue === "etc" && isEtcInquiryEnabledByEnsagaso) {
            // ログイン後のモーダル表示の速度改善のため、アニメーションを削除
            $("#js-modal-contact").toggleClass("stop");
            $("[id=etc]").prop("checked", true);
            $("#js-button-contact").click();
        }
    }

    // メモボタンを押したとき
    $(".js-nav-fixfooter__button-memo").on("click", function () {
        const nurseryId = $(this).data("nursery_id");

        pageDetail.review(nurseryId);
    });

    // お気に入りをおしたき
    $(".js-favorite-button").click(function (e) {
        // NOTE: この付近の施設のリンク内にあるボタンのためページ遷移するイベントをリセットしている
        if (e.target.classList.contains("js-prevent-default")) {
            e.preventDefault();
        }

        favorite.toggle(e.target.getAttribute("data-nursery_id"));
    });

    // 距離の計算
    const targetLatitude = $(".nursery-info").data("latitude");
    const targetLongitude = $(".nursery-info").data("longitude");

    $(".nursery-list__container, .nursery-list-mini__container").map(function () {
        const latitude = $(this).data("latitude");
        const longitude = $(this).data("longitude");
        const meter = distance.calcDistance(targetLatitude, targetLongitude, latitude, longitude);
        $(this).find(".distance").html(meter);
    });

    // マップを見るボタンを押したとき
    $(".js-map").click(function () {
        // outline以外のタブにいるときは#つきでリダイレクトする
        if ($("#gmap").length === 0) {
            const nursery_id = $(".js-detail-page").data("nursery_id");
            location.href = "/ns/" + nursery_id + "#gmap";
            return;
        }
        const headerHeight = $("header").outerHeight();
        const position = $("#gmap").offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, 500);
        return false;
    });

    // タブ切り替えページ遷移する
    $('input[name="tab-radio-button"]').change(function (e) {
        const nursery_id = $(".js-detail-page").data("nursery_id");
        const select_tab = $(e.target).data("select_tab");
        if (select_tab === "") {
            location.href = "/ns/" + nursery_id + "#page_top_anchor";
            return;
        }
        location.href = "/ns/" + nursery_id + "/" + select_tab + "#page_top_anchor";
    });

    // 内容のリンクの有効化。
    $(".js-autolink").map(function () {
        const textString = Autolinker.link($(this).html(), {
            stripPrefix: false,
            stripTrailingSlash: false,
            decodePercentEncoding: false,
            email: false,
            phone: false,
            replaceFn: function (match) {
                const tag = match.buildTag();
                tag.setAttr("rel", "nofollow").setAttr("class", "link-general");
                return tag;
            }
        });
        $(this).html(textString);
    });

    // 写真の部分の初期選択
    $("input[name='tab-radio-button2']").each(function () {
        if ($("label[for='" + $(this).attr("id") + "']").css("display") !== "none") {
            $(this).prop("checked", true);
            return false;
        }
    });

    // メモ更新のトースト表示
    const messageObject = $(".memo_flashMessage");
    if (messageObject.length !== 0) {
        const messageString = $(messageObject).data("flash_message");
        if (messageString !== "") {
            pageFavorite.showToastMessage(messageString);
        }
    }
});

$(window).on("load", function () {
    //slick
    $(".nursery-info__pic-slider").slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: "25%",
        variableWidth: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 600, // 600px以下のサイズに適用
                settings: {
                    centerMode: false,
                    variableWidth: false
                }
            }
        ]
    });
    $(".nursery-list.slider").slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        //variableWidth: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 1025, // 769~1024px以下のサイズに適用
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 769, // 480〜768px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480, // 〜479px以下のサイズに適用
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $(".nursery-list-mini.slider").slick({
        prevArrow: '<i class="fas fa-chevron-left"></i>',
        nextArrow: '<i class="fas fa-chevron-right"></i>',
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 769, // 480〜768px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480, // 〜479px以下のサイズに適用
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
